import React from 'react';
import { Flex, Box } from 'grid-styled';

import { Wrapper } from 'components/shared';

import FixNFlip from './FixNFlip';
import Rental from './Rental';
import NewConstruction from './NewConstruction';
import styled from 'styled-components';


function Products() {
  return (
    <Wrapper padded>
      <Title>Our Loan Products</Title>
      <Subtitle>Find the perfect financing solution for your real estate investment</Subtitle>
      <Flex flexWrap={['wrap', 'wrap', 'nowrap']} justify="center" items="stretch">
        <Box width={[1, 1, 1 / 3]} mb={[40, 40, 20]} mr={[0, 0, 40]}>
          <FixNFlip />
        </Box>

        <Box width={[1, 1, 1 / 3]} mb={[40, 40, 20]} mr={[0, 0, 40]}>
          <Rental />
        </Box>

        <Box width={[1, 1, 1 / 3]} mb={[40, 40, 20]}>
          <NewConstruction />
        </Box>
      </Flex>
    </Wrapper>
  );
}
const Title = styled.span`
  margin-bottom: 10px;
  display: block;
  text-align: center;
  font-size: var(--font-size-l);
  font-weight: 700;
  color: var(--color-primary);
`;
const Subtitle = styled.span`
  display: block;
  text-align: center;
  font-size: var(--font-size-s);
  font-weight: 300;
  color: var(--color-secondary-text);
  margin-bottom: 50px;
`;

export default Products;
